import { render, staticRenderFns } from "./AdminBillings.vue?vue&type=template&id=3c724ed9&"
import script from "./AdminBillings.vue?vue&type=script&lang=js&"
export * from "./AdminBillings.vue?vue&type=script&lang=js&"
import style0 from "./AdminBillings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports